import Skeleton from '@pixum/skeleton';
import clsx from 'clsx';
import styles from './ServiceBotSkeleton.module.css';

interface ServiceBotSkeletonProps {
  hidden: boolean;
  onTransitionEnd: () => void;
}

export function ServiceBotSkeleton({ hidden, onTransitionEnd }: ServiceBotSkeletonProps) {
  return (
    <div
      role="status"
      aria-busy={!hidden}
      aria-live="polite"
      aria-label="Service Bot wird geladen…"
      className={clsx(styles['skeleton'], hidden && styles['skeleton--hidden'])}
      onTransitionEnd={onTransitionEnd}
    >
      <div className={styles['skeleton__header']}>
        <Skeleton variant="circle" className={styles['skeleton__avatar']} />
        <div className={styles['skeleton__header-text']}>
          <Skeleton className={styles['skeleton__name']} />
          <Skeleton className={styles['skeleton__status']} />
        </div>
      </div>
      <div className={styles['skeleton__footer']}>
        <Skeleton className={styles['skeleton__input']} />
        <Skeleton variant="circle" className={styles['skeleton__send']} />
      </div>
    </div>
  );
}
